import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex flex-col items-center justify-center bg-background-50 overflow-hidden">
      <div className="relative z-10 w-full max-w-[900px] mx-auto px-6 text-center pt-24 pb-12">
        <div className="mb-4">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-medium">
            <i className="ri-sparkling-line text-sm"></i>
            2026 Complete Guide
          </span>
        </div>

        <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-extrabold text-foreground-950 leading-[1.15] mb-6">
          OOPBuy Spreadsheet Guide, Reviews &amp; How It Works
        </h1>

        <p className="text-base md:text-lg text-foreground-600 max-w-[680px] mx-auto leading-relaxed mb-8">
          Explore the complete <strong>OOPBuy Spreadsheet system</strong> — including how it works, step-by-step tutorials, safety insights, comparisons, and beginner guides designed for global users.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-6">
          <Link
            to="/oopbuy-spreadsheet-guide"
            onClick={() => window.scrollTo(0, 0)}
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
          >
            Read Full OOPBuy Spreadsheet Guide
            <i className="ri-arrow-right-line text-base"></i>
          </Link>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 border-2 border-primary-500 text-primary-600 font-semibold rounded-full hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer text-sm"
          >
            Visit Official Platform Now
            <i className="ri-arrow-right-up-line text-base"></i>
          </a>
        </div>

        <p className="text-xs text-foreground-400 max-w-[600px] mx-auto leading-relaxed">
          This website provides educational information only. We are an independent guide and do not process transactions or handle payments. Always verify sellers before purchasing.
        </p>
      </div>

      <div className="relative z-10 w-full overflow-hidden">
        <div className="flex gap-4 animate-[scrollLeft_35s_linear_infinite]">
          {heroImages.map((img, i) => (
            <div key={i} className="flex-shrink-0 w-[280px] h-[200px] md:w-[340px] md:h-[240px] rounded-2xl overflow-hidden bg-background-100">
              <img
                src={img}
                alt={`OOPBuy Spreadsheet product lifestyle image ${i + 1}`}
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          ))}
          {heroImages.map((img, i) => (
            <div key={`dup-${i}`} className="flex-shrink-0 w-[280px] h-[200px] md:w-[340px] md:h-[240px] rounded-2xl overflow-hidden bg-background-100">
              <img
                src={img}
                alt={`OOPBuy Spreadsheet product lifestyle image ${i + 1}`}
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes scrollLeft {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </section>
  );
}

const heroImages = [
  'https://readdy.ai/api/search-image?query=Stylish%20canvas%20backpack%20in%20olive%20green%20leaning%20against%20a%20moss%20covered%20stone%20wall%20in%20an%20urban%20garden%20setting%20with%20dappled%20sunlight%20filtering%20through%20leaves%2C%20editorial%20outdoor%20lifestyle%20photography%2C%20natural%20earthy%20tones%2C%20adventure%20and%20exploration%20mood%2C%20organic%20textures%20visible&width=680&height=480&seq=hero-deco-v2-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Pair%20of%20leather%20sandals%20placed%20on%20weathered%20wooden%20deck%20boards%20overlooking%20a%20coastal%20landscape%20at%20golden%20hour%2C%20travel%20lifestyle%20photography%2C%20warm%20amber%20and%20ocean%20blue%20tones%2C%20vacation%20mood%2C%20soft%20sea%20breeze%20implied%20by%20flowing%20fabric%20nearby&width=680&height=480&seq=hero-deco-v2-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Elegant%20wristwatch%20with%20leather%20strap%20resting%20on%20a%20stack%20of%20vintage%20hardcover%20books%20in%20a%20library%20nook%2C%20warm%20reading%20lamp%20illumination%2C%20sophisticated%20intellectual%20aesthetic%2C%20cognac%20brown%20and%20parchment%20tones%2C%20refined%20still%20life%20photography&width=680&height=480&seq=hero-deco-v2-03&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Lightweight%20quilted%20jacket%20in%20dusty%20rose%20draped%20over%20a%20bicycle%20handlebar%20on%20a%20cobblestone%20street%20in%20a%20European%20old%20town%2C%20golden%20late%20afternoon%20light%2C%20travel%20fashion%20editorial%2C%20romantic%20terracotta%20and%20limestone%20tones%2C%20lifestyle%20storytelling%20photography&width=680&height=480&seq=hero-deco-v2-04&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Minimalist%20sneakers%20in%20blush%20pink%20placed%20on%20a%20concrete%20step%20surrounded%20by%20fallen%20cherry%20blossom%20petals%2C%20spring%20urban%20photography%2C%20soft%20pastel%20tones%2C%20poetic%20street%20style%20aesthetic%2C%20delicate%20natural%20elements%20contrast%20with%20modern%20architecture&width=680&height=480&seq=hero-deco-v2-05&orientation=landscape',
];